import React from "react";
import { StyledEditableInput } from "../../../../../../../../components/inline-edit/styled";
import { useCardsStore } from "../../../../../../../../stores/use-cards-store";

function EditableInput({ inputProp = "", data, config, customStyles = {} }) {
  const { updateCardData, selectedCard, setCard } = useCardsStore((state) => ({
    updateCardData: state.updateCardData,
    selectedCard: state.card,
    setCard: state.setCard,
  }));

  if (!inputProp) return <></>;

  return (
    <StyledEditableInput
      style={{ ...customStyles }}
      size={data[inputProp].length + 1}
      value={data[inputProp]}
      onChange={(e) =>
        updateCardData({
          id: data.id,
          key: inputProp,
          value: e.target.value,
        })
      }
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!selectedCard || selectedCard?.card?.id !== data.id) {
          setCard({ card: data, config });
        }
      }}
    />
  );
}

export default EditableInput;
